import {
    AnimatePresence,
    motion,
    MotionProps,
    PanInfo
} from 'framer-motion';
import { INSIDE_LAYOUT_CONTENT_CONTAINER_ID } from 'layouts/common/inside/MprcLayoutInside';
import { ReactNode, useEffect, useRef } from 'react';
import { StyledItem } from './Styled';

export interface CarouselItemProps {
    animation: 'fade' | 'slide',
    next?: Function,
    prev?: Function,
    state: {
        active: number,
        prevActive: number,
        next: boolean;
    };
    swipe?: boolean,
    index: number,
    maxIndex: number,
    duration: number,
    child: ReactNode,
    setChildHeight: Function;
    observeWindowHeight: boolean;
}

export const CarouselItem = ({ animation, next, prev, swipe, state, index, maxIndex, duration, child, observeWindowHeight = false, setChildHeight }: CarouselItemProps) => {
    const dragProps: MotionProps = {
        drag: 'x',
        layout: false, //true,
        onDragEnd: (event: MouseEvent | TouchEvent | PointerEvent, info: PanInfo): void => {
            if (!swipe) return;

            if (info.offset.x > 0) prev && prev();
            else if (info.offset.x < 0) next && next();

            event.stopPropagation();
        },
        dragElastic: 0,
        dragConstraints: { left: 0, right: 0 }
    };

    /**
     * Container para os items do carrosel
     */
    const divRef = useRef<any>(null);

    /**
     * Observa o tamanho da Janela do Navegador.
     */
    const observer = new ResizeObserver(entries => {
        if (index !== state.active) return;
        if (!divRef.current) return;

        for (const entry of entries) {
            // each entry is an instance of ResizeObserverEntry
            setChildHeight(entry.contentRect.height);
        }
    });

    /**
     * Quando o Container é renderizado pela primeira vez
     */
    useEffect(() => {
        if (divRef.current) {
            if (observeWindowHeight)
                observer.observe(document.querySelector('#' + INSIDE_LAYOUT_CONTENT_CONTAINER_ID)!);
        }
        return () => {
            if (observeWindowHeight)
                observer.disconnect();
        };
    }, [divRef.current]);

    //
    useEffect(() => {
        if (!observeWindowHeight && divRef.current)
            setChildHeight(divRef.current.clientHeight);
    }, [divRef]);

    // Handle animation directions and opacity given based on active, prevActive and this item's index
    const { active, next: isNext } = state;

    return (
        <StyledItem id="carousel-item-position" observeWindowHeight={observeWindowHeight}>
            <AnimatePresence custom={isNext}>
                <motion.div id="carousel-motion-wrapper" {...(swipe && dragProps)} style={{ minHeight: "inherit", maxHeight: "inherit" }}>
                    <div
                        id="carousel-motion"
                        style={{ position: 'relative', minHeight: "inherit", maxHeight: "inherit", display: index == active ? "" : "none" }}
                    >
                        <div id="carousel-item-child" ref={divRef} style={{ minHeight: "inherit", maxHeight: "inherit" }}>
                            {child}
                        </div>
                    </div>
                </motion.div>
            </AnimatePresence>
        </StyledItem >
    );
};
